var map = {
	"./account-add.svg": "4997",
	"./account-remove.svg": "485b",
	"./account-remove_gray.svg": "d98e",
	"./account-remove_white.svg": "2932",
	"./alcohol.svg": "89c2",
	"./alert.svg": "3633",
	"./alert_white.svg": "6f94",
	"./approve.svg": "ef16",
	"./approve_gray.svg": "27ac",
	"./archive.svg": "e50d",
	"./arrow_down.svg": "f4b6",
	"./arrow_left.svg": "aaea",
	"./arrow_right.svg": "79c2",
	"./arrow_up.svg": "72a9",
	"./beheer.svg": "8271",
	"./berichten.svg": "2c0e",
	"./berichten_white.svg": "722c",
	"./book.svg": "a810",
	"./calendar.svg": "1acc",
	"./caseload.svg": "6427",
	"./catalogus.svg": "4673",
	"./chat.svg": "a017",
	"./check.svg": "c0e2",
	"./check_white.svg": "8ba1",
	"./close-alt.svg": "965b",
	"./close.svg": "3ad7",
	"./close_white.svg": "7967",
	"./cursor.svg": "ad71",
	"./dashboard.svg": "82b9",
	"./folder.svg": "3754",
	"./inbox.svg": "d486",
	"./kleurjeleven.svg": "b7d9",
	"./lightning.svg": "b554",
	"./lightning_white.svg": "1ee2",
	"./logout.svg": "f4b0",
	"./mail.svg": "4412",
	"./menu.svg": "f268",
	"./mind.svg": "991b",
	"./muscle.svg": "07db",
	"./notification.svg": "ab82",
	"./pencil.svg": "9bc2",
	"./pencil_white.svg": "b13e",
	"./people.svg": "98e5",
	"./person.svg": "9775",
	"./person_blue.svg": "273c",
	"./person_male.svg": "2d79",
	"./phone.svg": "4b19",
	"./plus-alt.svg": "433d",
	"./plus.svg": "66be",
	"./plus_white.svg": "9f12",
	"./profile-1.svg": "614b",
	"./profile-2.svg": "9022",
	"./profile-3.svg": "d9e3",
	"./profile-4.svg": "b2db",
	"./profile-5.svg": "d00c",
	"./profile-6.svg": "fef8",
	"./profile-7.svg": "4401",
	"./question-mark.svg": "ed93",
	"./question-mark_white.svg": "744c",
	"./refresh-alt.svg": "bcf2",
	"./refresh.svg": "8026",
	"./refresh_white.svg": "face",
	"./search.svg": "1045",
	"./send.svg": "9d4d",
	"./send_white.svg": "ebee",
	"./settings.svg": "50bf",
	"./spinner.svg": "dd2c",
	"./taken.svg": "90f0",
	"./thumb-up.svg": "c94d",
	"./trashcan.svg": "8ba8",
	"./trashcan_white.svg": "e246",
	"./unarchive.svg": "b27f",
	"./website.svg": "70b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1848";